module.exports = __webpack_public_path__ + "55462b36451ee17b070a44f55989ddd5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-soccer-s.png
// module id = 2586
// module chunks = 0